export default __webpack_public_path__ + "static/media/mustang-wrap-1.96729caa.jpg";